import React from 'react';
import PropTypes from 'prop-types';

const Text1Type = ({question}) => (
    <>
    </>
);

Text1Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default Text1Type;
